import React, { Component } from 'react';

class ProductGrid extends Component {

  render() {
    return (
        <div className="product-grid">
            <h3>{this.props.caption}</h3>
            {this.props.children}
        </div>
    );
  }
}

export default ProductGrid;



// WEBPACK FOOTER //
// ./src/components/ProductGrid/ProductGrid.js